import { displayShopFact } from '@/i18n/catalogDisplayText';
import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { countSiteRows, flattenSiteRows } from '@/tiktok-platform/utils/tiktokSiteList';

export default function ShopSiteListPanel({
  loading,
  error,
  siteList,
}) {
  const rows = flattenSiteRows(siteList);
  const siteCount = countSiteRows(siteList);
  const showAllSitesDefault = !loading && !error && siteCount === 0;

  return (
    <div className="tko-shop-info__panel" data-testid="tiktok-site-list">
      {loading ? <p className="tko-return-detail__empty">{fixedUi("正在加载站点信息…")}</p> : null}
      {error ? <p className="tko-shop-info__inline-error" role="alert">{error}</p> : null}

      {showAllSitesDefault ? (
        <div className="tko-shop-info__table-wrap">
          <table className="tko-shop-info__table">
            <thead>
              <tr>
                <th>{fixedUi("主站点")}</th>
                <th>{fixedUi("子站点")}</th>
                <th>{fixedUi("站点缩写")}</th>
                <th>{fixedUi("状态")}</th>
                <th>{fixedUi("店铺类型")}</th>
                <th>{fixedUi("币种")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>TikTok</td>
                <td>{fixedUi("全站点")}</td>
                <td><code>ALL</code></td>
                <td>{fixedUi("启用")}</td>
                <td>—</td>
                <td>—</td>
              </tr>
            </tbody>
          </table>
          <p className="tko-return-detail__empty" style={{ marginTop: 8 }}>
            {fixedUi("尚未同步到授权/经营站点；点击「拉取 TikTok 后台数据」获取授权/经营站点列表。")}
          </p>
        </div>
      ) : null}

      {!loading && !error && rows.length > 0 ? (
        <div className="tko-shop-info__table-wrap">
          <table className="tko-shop-info__table">
            <thead>
              <tr>
                <th>{fixedUi("主站点")}</th>
                <th>{fixedUi("子站点")}</th>
                <th>{fixedUi("站点缩写")}</th>
                <th>{fixedUi("状态")}</th>
                <th>{fixedUi("店铺类型")}</th>
                <th>{fixedUi("币种")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.key}>
                  <td>{displayShopFact(row.mainSiteName) || '—'}</td>
                  <td>{displayShopFact(row.siteName)}</td>
                  <td><code>{row.siteAbbr}</code></td>
                  <td>{displayShopFact(row.siteStatus)}</td>
                  <td>{displayShopFact(row.storeType)}</td>
                  <td>{row.currency}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
